export const getRange = (target: number) => {
  const numbers = [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];
  const ceil = Math.min(...numbers.filter((number) => number >= target));
  const floor = ceil - 100;
  return `${floor || 1} - ${ceil}`;
};
